import { useSelector } from "react-redux"

import CardGrey from "../../../common/CardGrey"
import DefaultUpdater from "../../../common/DefaultUpdater"
import OtherVehicleInformation from "../Shared/OtherVehicleInformation"
import { frontendOptions, stateOptions } from "../../../../lib/systemData"

import classes from '../Shared/Item.module.css'
import { isPrimaryInsurance } from "../../../../lib/primaryItemScripts"
import { getUMReducedAmount } from "../../../../lib/misc"
import GlobalTooltip from "../../../common/GlobalTooltip"
import { liabilityFunctions } from "../../../../lib/liability"

const MedpaySidebar = ({data, branch}) => {
    const activeCase = useSelector(state => state.case.activeCase) 

    const blockReducedOption = !data?.um_policy_limit_patient ? {value: 1, message: 'UM Limit Patient is required'} : null


    return <CardGrey minHeight={'100%'}>
        {branch == 'medpay' && <>
            <div className={classes.container}>

                {<div className={`${classes.sidebar_row_block} ${classes.sidebar_row_text_small}`}>
                    <DefaultUpdater
                        type={'select'}
                        value={data.insurance_state}
                        options={stateOptions()}
                        label={'Insurance State'}
                        identifier={{type: 'case_mp_pip_um', field: 'insurance_state', type_id: data.id, folder: 'mp_pip_um'}}
                        extraOptions={{hasRemove: true, optimistic: true}}
                    />
                </div>}

                <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                    <DefaultUpdater type={'checkbox'} value={data.commercial_policy} name={'commercial_policy'} label={'Commercial Policy'} identifier={{type: 'case_mp_pip_um', field: 'commercial_policy', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse'}}/>
                </div>

                <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                    <DefaultUpdater type={'checkbox'} value={data.ride_share} name={'ride_share'} label={'Rideshare'} identifier={{type: 'case_mp_pip_um', field: 'ride_share', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse'}}/>
                </div>
                
                <div className={`${classes.sidebar_row_block} ${classes.sidebar_row_text_small}`}>
                    <DefaultUpdater type={'input'} value={activeCase.additional.people_involved} name={'people_involved'} label={'People involved in the accident'} identifier={{type: 'case_additional', field: 'people_involved', type_id: null, folder: 'additional'}} extraOptions={{type: 'number'}}/>
                </div>
                
            </div>

            <div className={classes.sidebar_footer}>     
                <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                    <DefaultUpdater type={'checkbox'} value={data.mp_attorney_received_medpay} name={'mp_attorney_received_medpay'} label={'Atty Received Medpay'} identifier={{type: 'case_mp_pip_um', field: 'mp_attorney_received_medpay', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse'}}/>
                </div>
            </div>
        </>}

        {branch == 'um' && <>
            <div className={classes.container}>
                {(data.has_um == 1) ? <>
                    <div className={classes.sidebar_row_block}>
                        <h3 className={`${classes.sidebar_title} ${classes.sidebar_title_between}`}>
                            UM Type 
                            {data.um_type == 1 && getUMReducedAmount(isPrimaryInsurance(activeCase, 'liabilities', 'is_um_primary_insurance'), data) != null && 
                                <div className={classes.um_reduced_ammount}>
                                    Available: ${getUMReducedAmount(liabilityFunctions.isLiabilityValid(activeCase?.liabilities, 'policy_limit_patient'), data)} 
                                    <GlobalTooltip>
                                        {getUMReducedAmount(liabilityFunctions.isLiabilityValid(activeCase?.liabilities, 'policy_limit_patient'), data) ? 
                                            <>Your UM coverage is reduced by the at-fault driver’s liability. You can use the difference between your UM limit and their liability coverage.</>                                        
                                            :
                                            <>Your UM coverage is fully offset because the at-fault driver’s liability limit is equal to or higher than your UM limit</>
                                        }
                                    </GlobalTooltip>
                                </div>
                            }
                        </h3>
                        <DefaultUpdater type={'radio'} value={data.um_type} options={frontendOptions()?.umTypeRadioFields} name={'um_type'} label={'Select um status'} identifier={{type: 'case_mp_pip_um', field: 'um_type', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{normalSize: true, blockOption: blockReducedOption}}/>
                        
                    </div>
                    <div className={`${classes.sidebar_row} ${classes.sidebar_row_separator}`}></div>
                </> : '' }

                <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                    <DefaultUpdater type={'checkbox'} value={data.um_neg_split} name={'um_neg_split'} label={'Split'} identifier={{ type: 'case_mp_pip_um', field: 'um_neg_split', type_id: data.id, folder: 'mp_pip_um' }} extraOptions={{ direction: 'reverse' }} />
                </div>

                <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                    <DefaultUpdater type={'checkbox'} value={data.commercial_policy} name={'commercial_policy'} label={'Commercial Policy'} identifier={{type: 'case_mp_pip_um', field: 'commercial_policy', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse'}}/>
                </div>
                <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                    <DefaultUpdater type={'checkbox'} value={data.ride_share} name={'ride_share'} label={'Rideshare'} identifier={{type: 'case_mp_pip_um', field: 'ride_share', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse'}}/>
                </div>
                
                <div className={`${classes.sidebar_row_block} ${classes.sidebar_row_text_small}`}>
                    <DefaultUpdater type={'input'} value={activeCase.additional.people_involved} name={'people_involved'} label={'People involved in the accident'} identifier={{type: 'case_additional', field: 'people_involved', type_id: null, folder: 'additional', permissionType: branch == 'um' ? 'um' : 'case_mp_pip_um'}} extraOptions={{type: 'number'}}/>
                </div>
                
            </div>           
        </>}

        <div className={classes.sidebar_footer}> 

            <div className={`${classes.sidebar_row} ${classes.sidebar_row_separator}`}></div>

            <OtherVehicleInformation classes={classes} data={data} type={'case_mp_pip_um'} folder={'mp_pip_um'}/>

        </div>
    </CardGrey>
}

export default MedpaySidebar